import React from 'react';
import { Button } from "../ui/button";

const Pagination = ({
    currentPage,
    totalItems,
    rowsPerPage,
    handlePreviousPage,
    handleNextPage,
    handlePageClick,
}) => {
    const totalPages = Math.ceil(totalItems / rowsPerPage);

    if (totalPages <= 1) return null;

    const maxVisible = 7;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = startPage + maxVisible - 1;

    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxVisible + 1);
    }

    const visiblePages = [];
    for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
    }

    return (
        <div className="flex justify-center items-center mt-4 flex-wrap">
            <Button
                variant="outline"
                size="sm"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
            >
                ← Précédent
            </Button>

            {startPage > 1 && (
                <>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handlePageClick(1)}
                        className="mx-1"
                    >
                        1
                    </Button>
                    <span className="px-2 text-muted-foreground">...</span>
                </>
            )}

            {visiblePages.map((page) => (
                <Button
                    key={page}
                    variant={currentPage === page ? "default" : "outline"}
                    size="sm"
                    onClick={() => handlePageClick(page)}
                    className="mx-1"
                >
                    {page}
                </Button>
            ))}

            {endPage < totalPages && (
                <>
                    <span className="px-2 text-muted-foreground">...</span>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handlePageClick(totalPages)}
                        className="mx-1"
                    >
                        {totalPages}
                    </Button>
                </>
            )}

            <Button
                variant="outline"
                size="sm"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
            >
                Suivant →
            </Button>
        </div>
    );
};

export default Pagination;
